/* eslint-disable */
import { combineReducers } from 'redux';
import appReducer from './appReducer';

const reducers = combineReducers({ appReducer });

const rootReducer = (state, action) => {
	if (action.type === 'RESET_STATE') {
		// eslint-disable-next-line no-undefined
		state = undefined;
	}
	return reducers(state, action);
};

export default rootReducer;
